import { render, staticRenderFns } from "./svg.vue?vue&type=template&id=2389a1f1&scoped=true"
import script from "./svg.vue?vue&type=script&lang=js"
export * from "./svg.vue?vue&type=script&lang=js"
import style0 from "./svg.vue?vue&type=style&index=0&id=2389a1f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2389a1f1",
  null
  
)

export default component.exports